import React from 'react';
import { Contract } from '../contract.jsx';
import { useUiStore, useSyncBridge, useFlowStore, useFlowRegistry } from '../../store/react';

export default function ContractWrapper() {
    const bridge = useSyncBridge();
    const contractGenerated = useUiStore((s) => s.contractGenerated);
    const contract = useUiStore((s) => s.contract);
    const contractError = useUiStore((s) => s.contractError);
    const clearContract = useUiStore((s) => s.clearContract);
    const flowId = useFlowStore((s) => s.currentFlowId);
    const registry = useFlowRegistry();
    const outputLabel = registry.get(flowId)?.outputLabel;
    return (
        <Contract
            contractGenerated={contractGenerated}
            contract={contract}
            contractError={contractError}
            outputLabel={outputLabel}
            clearContract={clearContract}
            generateContract={() => bridge && bridge.generateContract()}
        />
    );
}
